import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const TRUSTED = new Set(['https://mohamedyousef.com','https://www.mohamedyousef.com']);
const pending = new Map();
let desired = null;
let generation = 0;
let retryTimer;
let retryCount = 0;
let initialized = false;

function available() {
  return TRUSTED.has(window.location.origin) && window.self === window.top &&
    window.MohamedDevice && typeof window.MohamedDevice.postMessage === 'function' &&
    /^https:\/\//.test(API_URL);
}
function initialize() {
  if (initialized) return;
  initialized = true;
  window.MohamedDevice.onmessage = event => {
    try {
      const reply = JSON.parse(event.data);
      const resolve = pending.get(reply.request_id);
      if (resolve) { pending.delete(reply.request_id); resolve(reply); }
    } catch (_) { /* Ignore malformed or unmatched replies. */ }
  };
  window.addEventListener('mohamed-native-device-changed',() => { retryCount = 0; synchronize(generation); });
  window.addEventListener('online',() => { retryCount = 0; synchronize(generation); });
  document.addEventListener('visibilitychange',() => { if (!document.hidden) synchronize(generation); });
}
function native(type, fields) {
  initialize();
  const request_id = window.crypto.randomUUID();
  return new Promise((resolve,reject) => {
    const timer = setTimeout(() => { pending.delete(request_id); reject(new Error('Native device unavailable')); },8000);
    pending.set(request_id, reply => { clearTimeout(timer); resolve(reply); });
    try { window.MohamedDevice.postMessage(JSON.stringify({type,request_id,...fields})); }
    catch (error) { clearTimeout(timer); pending.delete(request_id); reject(error); }
  });
}
async function synchronize(ticket) {
  clearTimeout(retryTimer);
  if (!available() || !desired || ticket !== generation) return;
  const snapshot = desired;
  try {
    const reply = await native('session',{session_key:snapshot.user.id});
    if (ticket !== generation || !reply.device?.token) {
      if (ticket === generation && !reply.device?.token) schedule(ticket);
      return;
    }
    const response = await axios.put(`${API_URL}/devices/current`,reply.device,{
      headers:{Authorization:`Bearer ${snapshot.token}`},timeout:15000,
    });
    if (ticket !== generation) return;
    const bound = await native('bound',{epoch:response.data.epoch,expires_at:response.data.expires_at,rotation_grant:response.data.rotation_grant});
    if (ticket === generation) {
      if (bound.ok) { retryCount = 0; retryTimer = setTimeout(() => synchronize(ticket),6 * 3600 * 1000); }
      else schedule(ticket);
    }
  } catch (error) {
    if (ticket !== generation) return;
    if ([401,403].includes(error.response?.status)) {
      await native('session',{session_key:''}).catch(() => {});
      return;
    }
    schedule(ticket);
  }
}
function schedule(ticket) {
  if (ticket !== generation || !desired) return;
  clearTimeout(retryTimer);
  retryTimer = setTimeout(() => synchronize(ticket),Math.min(300000,2000 * 2 ** Math.min(retryCount++,8)));
}
export function syncNativePush(user,token) {
  if (!available()) return;
  if (!user || !token || user.session_type === 'parent') { stopNativePush(); return; }
  desired = {user,token};
  retryCount = 0;
  synchronize(++generation);
}
export function stopNativePush() {
  const previous = desired;
  desired = null;
  ++generation;
  clearTimeout(retryTimer);
  if (!available()) return;
  // Local binding is cleared even when the backend is unreachable. Keep the
  // previous bearer only in this closure long enough to attempt revocation.
  native('session',{session_key:''}).then(reply => {
    if (previous?.token && reply.device) return axios.delete(`${API_URL}/devices/current`,{
      data:reply.device,headers:{Authorization:`Bearer ${previous.token}`},timeout:15000,
    });
    return undefined;
  }).catch(() => { /* Offline logout stays local; expiry/new login resolves server state. */ });
}
